export default "__VITE_ASSET__RNlv$ETf__"